import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import LocalizationConstants from "src/app/constants/localization-constants";
import { ModalComponent, ModalService } from "src/app/services/modal.service";

export type LocalizationLangCreateResult = { code: string; language: string };

@Component({
  selector: "app-localization-lang-create-modal",
  templateUrl: "./localization-lang-create-modal.component.html",
  standalone: false,
})
export class LocalizationLangCreateModalComponent
  implements
    ModalComponent<LocalizationLangCreateModalComponent, void, LocalizationLangCreateResult>
{
  localizationConstants = LocalizationConstants;

  constructor(
    public dialogRef: MatDialogRef<
      LocalizationLangCreateModalComponent,
      LocalizationLangCreateResult
    >,
    public modalService: ModalService,
  ) {}

  submitResult(result: LocalizationLangCreateResult) {
    this.dialogRef.close(result);
  }
}
